<svg [ngClass]="[getSize(), getColorClass()]">
  <use [attr.xlink:href]="'images/sprite.svg#' + name" />
</svg>
